/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { translate } from "react-i18next";

const ModalReject = ({ values, isSubmitting, handleSubmit, setFieldValue, t }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  useEffect(() => {
    getAllVendors();
  }, []);
  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
    if (values.rejection_reason) handleSubmit();
  };

  const getAllVendors = () => {
    CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  };
  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleType,
        key: item.vehicleTypeCode,
        value: item.vehicleTypeId,
      };
    });
    setVendors(result);
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            basic color="red"
            className="p-bold-600"
          >
            {t("reject") || "Reject"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{t("reject") || "Reject"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "12em" }}>
            <div className="ui form">
              <Fieldmik
                name="rejection_reason"
                className="form-control"
                component="textarea"
                placeholder='Enter Reason' />
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting || values.rejection_reason ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikReject = withFormik({
  mapPropsToValues() {
    return {
      rejection_reason: ""
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    console.log(values);
    let orderId = window.location.search.split("=")[1];
    let vendorId = localStorage.getItem("vendorId")
    let URL = ""

    if (props.OrderStatus == "active") {
      URL = `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}/broadcast/vendor/${vendorId}/reject`
    }
    else {
      URL = `${process.env.REACT_APP_TA_API_URL}/orders/${orderId}/vendor/${vendorId}/reject`
    }

    CreateAxios({
      completeURL: URL, payload: values,
    })
      .then((res) => {
        setSubmitting(false);
        console.log(res);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  },
})(ModalReject);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikReject)
);
